import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const VendorList = () => {
  const server_url = localStorage.getItem("server_url");
  const company_id = localStorage.getItem("company_id") || "2";
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const grage_id = userData.grage_id || "1";
  const navigate = useNavigate();

  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    vendor: null,
  });

  useEffect(() => {
    fetchVendors();
  }, []);

  useEffect(() => {
    if (searchText.trim() == "") {
      setFilteredVendors(vendors);
    } else {
      const filtered = vendors.filter(
        (vendor) =>
          (vendor.vendor_firm_name || "")
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          (vendor.vendor_name || "")
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          (vendor.vendor_mobile || "").includes(searchText) ||
          (vendor.vendor_gst_no || "")
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredVendors(filtered);
    }
  }, [searchText, vendors]);

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("vendor_grage_id", grage_id);
      formData.append("action", "view");

      const response = await axios.post(`${server_url}vendor.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(response.data);

      if (response.data.status == "1") {
        setVendors(response.data.result || []);
        setFilteredVendors(response.data.result || []);
      } else if (response.data.status == "3") {
        toast.error("Please login first");
        // navigate("/login");
      } else if (response.data.status == "0") {
        setVendors([]);
        setFilteredVendors([]);
        if (response.data.error !== "No data found") {
          toast.error(response.data.error || "Failed to fetch vendors");
        }
      } else {
        toast.error(response.data.error || "Failed to fetch vendors");
        setVendors([]);
        setFilteredVendors([]);
      }
    } catch (error) {
      console.error("Fetch vendors error:", error);
      toast.error("Unable to fetch vendors. Please try again.");
      setVendors([]);
      setFilteredVendors([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();
  };

  const handleEditVendor = (vendor) => {
    navigate("/edit-vendor", { state: { vendor } });
  };

  const handleAddVendor = () => {
    navigate("/add-vendor");
  };

  const handleViewTransactions = (vendor) => {
    navigate("/vendor-transactions", { state: { vendor } });
  };

  const handleAddTransaction = (vendor) => {
    navigate("/add-vendor-transaction", { state: { vendor } });
  };

  const openDeleteModal = (vendor) => {
    setDeleteModal({ isOpen: true, vendor });
  };

  const closeDeleteModal = () => {
    setDeleteModal({ isOpen: false, vendor: null });
  };

  const confirmDeleteVendor = async () => {
    const vendor = deleteModal.vendor;
    if (!vendor) return;

    setDeleteLoading(vendor.vendor_id);
    try {
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("vendor_id", vendor.vendor_id);
      formData.append("vendor_grage_id", grage_id);
      formData.append("action", "delete");

      const response = await axios.post(`${server_url}vendor.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status == "1") {
        toast.success("Vendor deleted successfully!");
        setVendors((prev) =>
          prev.filter((i) => i.vendor_id !== vendor.vendor_id)
        );
        setFilteredVendors((prev) =>
          prev.filter((i) => i.vendor_id !== vendor.vendor_id)
        );
        closeDeleteModal();
      } else {
        toast.error(response.data.error || "Failed to delete vendor");
      }
    } catch (error) {
      console.error("Delete vendor error:", error);
      toast.error("Unable to delete vendor. Please try again.");
    } finally {
      setDeleteLoading(null);
    }
  };

  const formatAmount = (amount) => {
    return parseInt(amount || 0).toLocaleString("en-IN");
  };

  return (
    <div className="history-container">
      {/* Sticky Header Section */}
      <div
        className="sticky-filter"
        style={{ position: "fixed", top: "56px", width: "100%" }}
      >
        <div className="home-icon">
          <div className="section-home">
            {/* Search Bar */}
            <div style={{ marginTop: "10px" }}>
              <div className="input-group same-line">
                <input
                  type="text"
                  placeholder="Search by firm name, contact person, or mobile..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => e.key == "Enter" && handleSearch()}
                  className="search-input"
                />
                <button
                  type="button"
                  onClick={handleSearch}
                  className="search-btn"
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="content-area vendorlist">
        {/* Vendor List */}
        <div className="home-vehicles">
          {loading ? (
            <div className="loading-vehicles">
              <div className="loading-spinner"></div>
              <div>Loading vendors...</div>
            </div>
          ) : filteredVendors.length > 0 ? (
            <div className="vehicles-list home-icon">
              {filteredVendors.map((vendor) => (
                <div
                  key={vendor.vendor_id}
                  className="vehicle-card section-home"
                  style={{
                    borderLeft: "4px solid #0352a1",
                  }}
                >
                  <div className="vehicle-header">
                    <table style={{ width: "100%", textAlign: "left" }}>
                      <tbody>
                        {/* Firm Name and Actions */}
                        <tr>
                          <td
                            style={{
                              width: "70%",
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                            onClick={() => handleEditVendor(vendor)}
                          >
                            {vendor.vendor_firm_name || ""}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              width: "30%",
                            }}
                          >
                            <button
                              onClick={() => openDeleteModal(vendor)}
                              disabled={deleteLoading == vendor.vendor_id}
                              style={{
                                border: "none",
                                cursor: "pointer",
                                fontSize: "19px",
                                fontWeight: "500",
                                backgroundColor: "transparent",
                                color: "#DB4437",
                              }}
                              title="Delete Vendor"
                            >
                              {deleteLoading == vendor.vendor_id ? (
                                <i className="fas fa-spinner fa-spin"></i>
                              ) : (
                                <i className="fas fa-trash"></i>
                              )}
                            </button>
                          </td>
                        </tr>

                        {/* Contact Person */}
                        <tr>
                          <td
                            style={{
                              fontSize: "14px",
                              color: "#2c3e50",
                              padding: "4px 0",
                            }}
                            onClick={() => handleEditVendor(vendor)}
                          >
                            <i
                              className="fas fa-user"
                              style={{ marginRight: "8px" }}
                            ></i>
                            {vendor.vendor_name || "N/A"}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              fontSize: "14px",
                              fontWeight: "600",
                              color:
                                parseFloat(vendor.vendor_outstanding || 0) > 0
                                  ? "#dc2626"
                                  : "#10b981",
                              paddingTop: "8px",
                            }}
                            onClick={() => handleEditVendor(vendor)}
                          >
                            ₹{formatAmount(vendor.vendor_outstanding)}
                          </td>
                        </tr>

                        {/* Mobile and Email */}
                        <tr>
                          <td
                            style={{
                              fontSize: "13px",
                              color: "#666",
                              padding: "2px 0",
                            }}
                            onClick={() => handleEditVendor(vendor)}
                          >
                            <i
                              className="fas fa-phone rotate90"
                              style={{ marginRight: "8px" }}
                            ></i>
                            <a href={`tel:${vendor.vendor_mobile}`}>
                              {vendor.vendor_mobile || ""}
                            </a>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              fontSize: "13px",
                              color: "#666",
                            }}
                            onClick={() => handleEditVendor(vendor)}
                          >
                            {vendor.vendor_gst_no && (
                              <>GST:{vendor.vendor_gst_no}</>
                            )}
                          </td>
                        </tr>

                        {/* Email and Outstanding */}
                        <tr>
                          <td
                            colSpan="2"
                            style={{
                              fontSize: "13px",
                              color: "#666",
                              padding: "2px 0",
                            }}
                            onClick={() => handleEditVendor(vendor)}
                          >
                            {vendor.vendor_email && (
                              <>
                                <i
                                  className="fas fa-envelope"
                                  style={{ marginRight: "8px" }}
                                ></i>
                                <a href={`mailto:${vendor.vendor_email}`}>
                                  {vendor.vendor_email}
                                </a>
                              </>
                            )}
                          </td>
                        </tr>

                        {/* Address (if available) */}
                        {vendor.vendor_address && (
                          <tr>
                            <td
                              colSpan="2"
                              style={{
                                fontSize: "13px",
                                color: "#666",
                                padding: "8px 0 4px 0",
                                fontStyle: "italic",
                              }}
                              onClick={() => handleEditVendor(vendor)}
                            >
                              <i
                                className="fas fa-map-marker-alt"
                                style={{ marginRight: "8px" }}
                              ></i>
                              {vendor.vendor_address.length > 50
                                ? vendor.vendor_address.substring(0, 50) + "..."
                                : vendor.vendor_address}
                            </td>
                          </tr>
                        )}

                        {/* Action Buttons */}
                        <tr>
                          <td colSpan="2" style={{ paddingTop: "12px" }}>
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                flexWrap: "wrap",
                              }}
                            >
                              {/* View Transactions */}
                              <button
                                onClick={() => handleViewTransactions(vendor)}
                                style={{
                                  background: "#3b82f6",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  flex: 1,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px",
                                }}
                              >
                                <i className="fas fa-history"></i>
                                Transactions
                              </button>

                              {/* Add Transaction */}
                              <button
                                onClick={() => handleAddTransaction(vendor)}
                                style={{
                                  background: "#10b981",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  flex: 1,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px",
                                }}
                              >
                                <i className="fas fa-plus-circle"></i>
                                Add Transaction
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-vehicles section-home">
              <div className="no-vehicles-icon">🏢</div>
              <div className="no-vehicles-title">No Vendors Found</div>
              <div className="no-vehicles-text">
                {searchText
                  ? "Try adjusting your search terms"
                  : "No vendors added yet. Add your first vendor!"}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Floating Add Button */}
      <button
        className="floating-add-btn"
        onClick={handleAddVendor}
        title="Add New Vendor"
      >
        <i className="fas fa-plus plusbuitton"></i>
      </button>

      {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "350px",
              padding: "24px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                margin: "0 auto 20px",
                backgroundColor: "#fee2e2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-exclamation-triangle"
                style={{ fontSize: "24px", color: "#dc2626" }}
              ></i>
            </div>

            <h3
              style={{
                margin: "0 0 12px 0",
                fontSize: "18px",
                fontWeight: "600",
                color: "#1f2937",
              }}
            >
              Delete Vendor
            </h3>
            <p
              style={{
                margin: "0 0 24px 0",
                color: "#6b7280",
                fontSize: "14px",
              }}
            >
              Are you sure you want to delete vendor{" "}
              <strong>{deleteModal.vendor?.vendor_firm_name}</strong>? This will
              also delete all associated transactions. This action cannot be
              undone.
            </p>

            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={closeDeleteModal}
                disabled={deleteLoading !== null}
                style={{
                  flex: 1,
                  padding: "12px",
                  border: "2px solid #e2e8f0",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteVendor}
                disabled={deleteLoading !== null}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "#dc2626",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {deleteLoading == deleteModal.vendor?.vendor_id ? (
                  <>
                    <i
                      className="fas fa-spinner fa-spin"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Deleting...
                  </>
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .plusbuitton {
          margin: 7px 0px 0px 5px;
          font-size: 35px !important;
        }
        @media (max-width: 480px) {
          .content-area {
            padding-top: 70px !important;
          }
        }
        .history-container {
          min-height: 100vh;
          background: white;
          padding: 0;
          position: relative;
        }

        .sticky-filter {
          position: sticky;
          top: 0;
          z-index: 100;
          background: white;
          padding: 8px 0;
          border-bottom: 1px solid #e2e8f0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .content-area {
          padding-top: 100px;
          padding-bottom: 80px;
        }

        .home-icon .section-home {
          padding: 8px 12px 12px 12px;
        }
        .home-icon {
          padding-left: 0px;
          padding-right: 0px;
        }

        .input-group.same-line {
          display: flex;
          gap: 8px;
          align-items: center;
        }

        .search-input {
          flex: 1;
          padding: 10px 12px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 14px;
          background: #f8f9fa;
        }

        .search-btn {
          background: #0352a1;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 10px 12px;
          min-width: 40px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .home-vehicles {
          padding: 20px 10px;
        }

        .loading-vehicles {
          text-align: center;
          padding: 40px 20px;
          color: #666;
        }

        .loading-spinner {
          width: 30px;
          height: 30px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #0352a1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .vehicles-list {
          display: grid;
          gap: 15px;
        }

        .vehicle-card {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 16px;
          border-left: 4px solid #0352a1;
          transition: all 0.3s ease;
        }

        .vehicle-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .vehicle-header {
          width: 100%;
        }

        .vehicle-header table {
          width: 100%;
          border-collapse: collapse;
        }

        .vehicle-header td {
          padding: 4px 0;
          vertical-align: top;
        }

        .no-vehicles {
          text-align: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 12px;
          margin: 20px 0;
        }

        .no-vehicles-icon {
          font-size: 48px;
          margin-bottom: 15px;
        }

        .no-vehicles-title {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 8px;
        }

        .no-vehicles-text {
          color: #666;
          margin-bottom: 20px;
          line-height: 1.4;
        }

        .floating-add-btn {
          position: fixed;
          bottom: 80px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: #0352a1;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: "center";
          justify-content: "center";
          font-size: 24px;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(3, 82, 161, 0.3);
          z-index: 99;
          transition: all 0.3s ease;
          border: none;
        }

        .floating-add-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 16px rgba(3, 82, 161, 0.4);
        }

        .floating-add-btn:active {
          transform: scale(0.95);
        }

        @media (max-width: 768px) {
          .content-area {
            padding-top: 100px;
          }

          .home-vehicles {
            padding: 15px 8px;
          }

          .vehicle-card {
            padding: 12px;
          }

          .vehicle-header td {
            font-size: 14px;
          }

          .sticky-filter {
            padding: 6px 0;
          }

          .search-input {
            min-width: 120px;
          }

          .floating-add-btn {
            bottom: 70px;
            right: 15px;
            width: 56px;
            height: 56px;
            font-size: 22px;
          }
        }

        @media (max-width: 480px) {
          .content-area {
            padding-top: 90px;
          }

          .sticky-filter {
            padding: 4px 0;
          }

          .input-group.same-line {
            gap: 6px;
          }

          .search-input {
            font-size: 13px;
            padding: 8px 10px;
          }

          .search-btn {
            padding: 8px 10px;
            min-width: 36px;
          }

          .floating-add-btn {
            bottom: 60px;
            right: 12px;
            width: 52px;
            height: 52px;
            font-size: 20px;
          }
        }
   
        .rotate90 {
          transform: rotateZ(90deg);
        }
      `}</style>
    </div>
  );
};

export default VendorList;
